'use strict'

import CONFIG from '@symbo.ls/config'
export default CONFIG
